import $ from 'zepto';

import { ajaxify } from './strings';

/**
 * removes extra and add default properties to the config
 *
 * @param {object} config.type request type [GET, POST, ...]
 * @param {object} config.url request url without ajax prefix
 * @param {object} [config.data] data to be sent to the server
 * @param {function} callback
 * @returns {object}
 */
export const sanitizeConfig = ({ type, url, data }, callback) => ({
  type,
  data,
  dataType: 'html',
  url: ajaxify(url),
  success: (html) => callback(undefined, html),
  error: (error) => callback(error),
});

/**
 * creates an ajax request sanitizing the config
 *
 * @param {Object} config
 * @param {Function} callback
 */
export const requestHtml = (config, callback) => $.ajax(sanitizeConfig(config, callback));

/**
 * shortcut to create GET requests using requestHtml
 *
 * @param {string} url
 * @param {function} callback
 */
export const getHtml = (url, callback) => requestHtml({
  url,
  type: 'GET',
}, callback);

/**
 * Creates safe callback to GET request redirecting to the provided
 * url if there is an error
 *
 * @example
 * getHtml(config, safeGet((url, html) => {
 *   ...
 * }));
 * @param {string} pathname url in case the request fails
 * @param {function} callback
 * @returns {(err: number, html: string) => ()} callback
 */
export const safeGet = (pathname, callback) => (error, html) => {
  if (error) {
    // this makes sure that the users won't
    // get stuck in the current view
    // eslint-disable-next-line no-restricted-globals
    location.pathname = pathname;
  } else {
    callback(html);
  }
};
